import { apiClient, createSuccessResponse, handleApiError } from "./api";

const serviceService = {
  async list(page = 1, pageSize = 10, filters = {}, sortBy = null, sortOrder = null) {
    try {
      const params = new URLSearchParams({
        page: page.toString(),
        pageSize: pageSize.toString(),
        ...filters
      });

      // Adicionar parâmetros de ordenação se fornecidos
      if (sortBy) {
        params.append('sortBy', sortBy);
      }
      if (sortOrder) {
        params.append('sortOrder', sortOrder);
      }

      const retorno = await apiClient.get(`/service?${params.toString()}`);

      return {
        data: retorno.data.data,
        pagination: retorno.data.pagination,
      };
    } catch (error) {
      const processedError = handleApiError(error);
      console.error("❌ [serviceService] Erro ao listar serviços:", processedError);
      return {
        success: false,
        message: processedError.message,
        status: processedError.status,
        error: processedError.error,
        code: processedError.code,
        details: processedError.details,
      };
    }
  },

  async listActive(page = 1, pageSize = 10) {
    try {
      const retorno = await apiClient.get(`/service/active?page=${page}&pageSize=${pageSize}`);

      return {
        data: retorno.data.data,
        pagination: retorno.data.pagination,
      };
    } catch (error) {
      const processedError = handleApiError(error);
      return {
        success: false,
        message: processedError.message,
        status: processedError.status,
        error: processedError.error,
        code: processedError.code,
        details: processedError.details,
      };
    }
  },

  async listServiceActive(page = 1, pageSize = 10) {
    try {
      const retorno = await apiClient.get(`/service/active?page=${page}&pageSize=${pageSize}`);

      return {
        data: retorno.data.data,
        pagination: retorno.data.pagination,
      };
    } catch (error) {
      const processedError = handleApiError(error);
      return {
        success: false,
        message: processedError.message,
        status: processedError.status,
        error: processedError.error,
        code: processedError.code,
        details: processedError.details,
      };
    }
  },

  async listQtdInsert() {
    try {
      const retorno = await apiClient.get("/qtdinsert");
      if (retorno && retorno.data) {
        return retorno.data;
      }
      return [];
    } catch (error) {
      const processedError = handleApiError(error);
      return {
        success: false,
        message: processedError.message,
        status: processedError.status,
        error: processedError.error,
        code: processedError.code,
        details: processedError.details,
      };
    }
  },

  async listFilter(id) {
    try {
      const retorno = await apiClient.get("/service/filter/" + id);
      if (retorno && retorno.data) {
        return retorno.data;
      }
      return [];
    } catch (error) {
      const processedError = handleApiError(error);
      return {
        success: false,
        message: processedError.message,
        status: processedError.status,
        error: processedError.error,
        code: processedError.code,
        details: processedError.details,
      };
    }
  },

  async edit(id) {
    try {
      const retorno = await apiClient.get("/service/" + id);
      if (retorno && retorno.data) {
        return createSuccessResponse(
          retorno.data,
          retorno.status,
          retorno.message
        );
      }
      return {
        success: false,
        message: "Serviço não encontrado",
        status: 404,
        error: "Serviço não encontrado",
        code: "NOT_FOUND",
        details: "Serviço não encontrado",
      };
    } catch (error) {
      const processedError = handleApiError(error);
      return {
        success: false,
        message: processedError.message,
        status: processedError.status,
        error: processedError.error,
        code: processedError.code,
        details: processedError.details,
      };
    }
  },

  async save(customer) {
    try {
      console.log(customer);
      const retorno = await apiClient.post("/service", customer);
      if (retorno && retorno.data) {
        return createSuccessResponse(
          retorno.data,
          retorno.status,
          retorno.message
        );
      }
      return createSuccessResponse(retorno, retorno.status, retorno.message);
    } catch (error) {
      const processedError = handleApiError(error);
      return {
        success: false,
        message: processedError.message,
        status: processedError.status,
        error: processedError.error,
        code: processedError.code,
        details: processedError.details,
      };
    }
  },

  async update(customer) {
    try {
      console.log(customer);
      const retorno = await apiClient.put("/service", customer);
      if (retorno && retorno.data) {
        return createSuccessResponse(
          retorno.data,
          retorno.status,
          retorno.message
        );
      }
      return createSuccessResponse(retorno, retorno.status, retorno.message);
    } catch (error) {
      const processedError = handleApiError(error);
      return {
        success: false,
        message: processedError.message,
        status: processedError.status,
        error: processedError.error,
        code: processedError.code,
        details: processedError.details,
      };
    }
  },

  async delete(idcustomer) {
    try {
      const retorno = await apiClient.delete("/service/" + idcustomer);
      if (retorno && retorno.data) {
        return createSuccessResponse(
          retorno.data,
          retorno.status,
          retorno.message
        );
      }
      return createSuccessResponse(retorno, retorno.status, retorno.message);
    } catch (error) {
      const processedError = handleApiError(error);
      return {
        success: false,
        message: processedError.message,
        status: processedError.status,
        error: processedError.error,
        code: processedError.code,
        details: processedError.details,
      };
    }
  },
};

export default serviceService;
